import { jwt } from "@/event/jwt/jwt";
import stores from "@/storage/stores";
import { fetchMe } from "./fetchMe";
import { isAuthenticated } from "@/event/account/auth/authentification";
import customer from "@/storage/customer";
import orders from "@/storage/orders";
import address from "@/storage/address";
import { isAppleDevice } from "../fetch/isAppleDevice";
import { getTokenByDevice } from "./getTokenByDevice";
import { setTokenDevice } from "./setTokenDevice";

export async function checkAndRefreshTokenV2() {
    try {
        const store = stores.getStoresData();
        const storeName = store.name;

        const data = getTokenByDevice()

        const result = await fetchMe(data)

        setTokenDevice(result);

        if (result && result.class === 'success') {
            // customer.setCustomerData(result.customer);
            // orders.setOrderData(result.customer.orders);
            // address.setAddressData(result.customer.addresses);

            isAuthenticated.value = true
        }

        return result
    } catch (error) {
        return false
    }
}